module.exports = __webpack_public_path__ + "img/froot_logo.eb674ca1.jpg";